import { render, staticRenderFns } from "./SendOrderModal2.vue?vue&type=template&id=a1d2e606&"
import script from "./SendOrderModal2.vue?vue&type=script&lang=js&"
export * from "./SendOrderModal2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports